import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/education-savings-calculator',
  component: () => import('../../routes/EducationSavings.svelte'),
  card: {
    id: 'education-savings-calculator',
    title: 'Education Savings Calculator',
    description:
      'Plan for college costs with 529 savings projections. See how much to save monthly to fund your child\'s education.',
    icon: 'school',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/education-savings-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Education Savings Calculator – 529 Plan College Cost Planner',
    description:
      'Plan your child\'s college education with our free 529 savings calculator. Project tuition costs, see how much to save monthly, and track your progress toward funding a 4-year degree.',
  },
};

export default meta;
